import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { z } from 'zod';

import { FieldsMap } from '@fields/feature';

const searchSchema = z.object({
  bbox: z.array(z.number()).length(4).optional(),
  fitBounds: z.coerce.number().optional(),
  ilotId: z.number().int().positive().optional(),
  pointId: z.number().int().positive().optional(),
  pointCode: z.string().optional(),
  sampleId: z.number().int().positive().optional(),
  lng: z.coerce.number().optional(),
  lat: z.coerce.number().optional(),
  zoom: z.coerce.number().optional(),
  scope: z.enum(['personal', 'organization']).optional(),
});

export const Route = createFileRoute('/_app/map')({
  validateSearch: zodSearchValidator(searchSchema),
  component: FieldsMap,
  errorComponent: FieldsMap.Error,
});
